module.exports = __webpack_public_path__ + "static/media/door.40de9fc1.mp3";